// extracted by mini-css-extract-plugin
module.exports = {"logout":"Logout-button_logout__m6CGA"};